var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"exitMenu"},[_c('transition',[_c('div',[_c('li',{staticClass:"nav__item exit_item",on:{"click":_vm.navBack}},[_c('i',{staticClass:"nav__item--icon"}),_vm._v(" "),_c('span',{staticClass:"nav__item--label"},[_vm._v("Back to main blog")])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-427ac16b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlogNav.vue
// module id = 153
// module chunks = 0